export default "__VITE_ASSET__aGKqyorL__";